import AddIcon from "@mui/icons-material/Add";
import WavingHandIcon from "@mui/icons-material/WavingHand";
import { useGlobalContext } from "@root/context";
import { useEffect, useState } from "react";
import { versionWithoutMinor } from "./logics";
import { StonlyFab, StonlyPaper, classes, classesFab } from "./styles";

export const Stonly = () => {
  const { user } = useGlobalContext();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const localVersion = window.localStorage.getItem("versionHorizon") ?? "0.0.0";

    if (versionWithoutMinor(localVersion) !== versionWithoutMinor(__APP_VERSION__)) {
      setOpen(true);
      window.localStorage.setItem("versionHorizon", __APP_VERSION__);
    }
  }, []);

  if (user.organisation.features.stonly.active) {
    return (
      <>
        {open && (
          <StonlyPaper elevation={2} className={classes.root}>
            <iframe
              style={{ border: "0", height: "100%", width: "100%" }}
              title="StonlyExplanation"
              name="StonlyExplanation"
              id="ston-cCIUADHHtM"
              allow="fullscreen"
              src="https://stonly.com/embed/fr/cCIUADHHtM/view/"
            />
          </StonlyPaper>
        )}
        <StonlyFab color="secondary" className={classesFab.root} onClick={() => setOpen(!open)}>
          {open ? (
            <AddIcon data-testid="StonlyAddIcon" className={classesFab.icon} />
          ) : (
            <WavingHandIcon data-testid="StonlyHandIcon" className={classesFab.wavingIcon} />
          )}
        </StonlyFab>
      </>
    );
  }
  return null;
};
